require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/array/from.js
// module id = 1222
// module chunks = 0